import {
  BooleanApiData,
  CancelPaymentRequest,
  AdminPaymentDTO,
  RefundPaymentRequest,
  AdminCompanyPurchaseDTO,
  BaseIdRequest,
} from '../../../../api/data-contracts'
import moment from 'moment'
import {useDispatch, useSelector} from 'react-redux'
import {ProductTypeEnum, UserTypeAuthorizationsEnum} from '../../../../apiClient/enums'
import _ from 'lodash'
import {
  Api_Admin_CancelPayment,
  Api_Admin_RefundPayment,
  Api_Admin_RestartPurchase,
  Api_Admin_StopPurchase,
} from '../../../../apiClient/apiClient'
import {postRequestAsync} from '../../../../redux/commonSlice'
import BootstrapTable, {ColumnDescription} from 'react-bootstrap-table-next'
import AreYouSurePopup from '../../../common/popup/AreYouSurePopup'
import Translator from '../../../common/translate/Translator'
import TranslatorText from '../../../common/translate/TranslatorText'
import {getAdminState} from '../../../../redux/adminSlice'
import clsx from 'clsx'
import {getPaymentStateColor} from '../../../../utils/utilities'
import AuthorizedComponent from '../../../common/auth/AuthorizedComponent'
import BasePopup, {PopupProvides} from '../../../common/popup/BasePopup'
import AdminPurchasePriceUpdate from './AdminPurchasePriceUpdate'
import AdminPaymentPriceUpdate from './AdminPaymentPriceUpdate'
function AdminCompanyPurchases(props: {load?: () => void}) {
  const dispatch = useDispatch()
  const adminState = useSelector(getAdminState)

  function cancelPayment(paymentId: number) {
    const body: CancelPaymentRequest = {
      paymentId: paymentId,
    }

    dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Admin_CancelPayment,
        body: body,
      })
    )
      .unwrap()
      .then(async function (response: BooleanApiData) {
        if (response.data) {
          props.load && props.load()
        }
      })
  }

  function stopPurchase(purchaseId: number) {
    const body: BaseIdRequest = {
      id: purchaseId,
    }

    dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Admin_StopPurchase,
        body: body,
      })
    )
      .unwrap()
      .then(async function (response: BooleanApiData) {
        if (response.data) {
          props.load && props.load()
        }
      })
  }

  function startPurchase(purchaseId: number) {
    const body: BaseIdRequest = {
      id: purchaseId,
    }
    dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Admin_RestartPurchase,
        body: body,
      })
    )
      .unwrap()
      .then(async function (response: BooleanApiData) {
        if (response.data) {
          props.load && props.load()
        }
      })
  }

  function refundPayment(paymentId: number) {
    const body: RefundPaymentRequest = {
      paymentId: paymentId,
    }

    dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Admin_RefundPayment,
        body: body,
      })
    )
      .unwrap()
      .then(async function (response: BooleanApiData) {
        if (response.data) {
          props.load && props.load()
        }
      })
  }

  const detailsColumns: ColumnDescription[] = [
    {
      dataField: 'dueDate',
      text: TranslatorText('ODENMESI_GEREKEN_ZAMAN') ?? '',
      sort: true,
      headerStyle: {width: '10%'},
      headerClasses: 'text-center',
      formatter: (cell: any, row: AdminPaymentDTO, rowIndex: number) =>
        rowIndex > 0 ? (
          <div className='text-center'>{moment(row.dueDate).format('DD.MM.yyyy')}</div>
        ) : null,
    },
    {
      dataField: 'paymentTime',
      text: TranslatorText('ODEME_ZAMANI') ?? '',
      sort: true,
      headerStyle: {width: '10%'},
      headerClasses: 'text-center',
      formatter: (cell: any, row: AdminPaymentDTO) => (
        <div className='text-center'>
          {row.paymentTime && moment(row.paymentTime).format('DD.MM.yyyy')}
        </div>
      ),
    },
    {
      dataField: 'paymentState',
      text: TranslatorText('ODEME_DURUMU') ?? '',
      sort: true,
      headerStyle: {width: '15%'},
      headerClasses: 'text-center',
      formatter: (cell: any, row: AdminPaymentDTO) => (
        <div className='text-center'>
          <span className={clsx('badge', getPaymentStateColor(row.paymentState ?? 0))}>
            {row.paymentStateDescription}
          </span>
          {row.isDebt && row.errorInfo && (
            <span className='badge bg-danger mt-2'>{row.errorInfo}</span>
          )}
        </div>
      ),
    },
    {
      dataField: 'isInvoicePrinted',
      text: TranslatorText('FATURA_DURUMU') ?? '',
      sort: true,
      headerStyle: {width: '10%'},
      headerClasses: 'text-center',
      formatter: (cell: any, row: AdminPaymentDTO) => (
        <div className={row.isInvoicePrinted ? 'text-success' : 'text-danger'}>
          {!row.invoiceUrl && (
            <div className='row'>
              <div className='text-center'>{row.isInvoicePrinted ? 'Basıldı' : 'Basılmadı'}</div>
            </div>
          )}
          <AuthorizedComponent
            auth={UserTypeAuthorizationsEnum.Admin_Panel_Company_Invoice_Download}
          >
            {row.invoiceUrl && (
              <div className='row'>
                <div className='d-flex justify-content-center align-items-start'>
                  <a
                    className='btn btn-sm btn-primary'
                    href={row.invoiceUrl ?? ''}
                    target='_blank'
                    rel='noreferrer'
                  >
                    <span className='indicator-label'>
                      <Translator name='FATURA_PDF_INDIR' />
                    </span>
                  </a>
                </div>
              </div>
            )}
          </AuthorizedComponent>
        </div>
      ),
    },
    {
      dataField: 'actions',
      text: 'İade / İptal',
      headerStyle: {width: '10%'},
      headerClasses: 'text-center',
      formatter: (cell: any, row: AdminPaymentDTO) => (
        <>
          {row.isRefundable && process.env.REACT_APP_ENV !== 'PROD' && (
            <div className='row'>
              <div className='d-flex justify-content-center align-items-start'>
                <AreYouSurePopup
                  modalOpener={
                    <div className='btn btn-sm btn-info px-10'>
                      <Translator name='IADE_ET' />
                    </div>
                  }
                  message={'IADE_ETMEK_ISTEDIGINIZDEN_EMIN_MISINIZ'}
                  onClick={() => refundPayment(row.paymentId ?? 0)}
                />
              </div>
            </div>
          )}

          {row.isCancellable && (
            <div className='row'>
              <div className='d-flex justify-content-center align-items-start'>
                <AreYouSurePopup
                  modalOpener={
                    <div className='btn btn-sm btn-danger px-10'>
                      <Translator name='IPTAL_ET' />
                    </div>
                  }
                  message={'IPTAL_ETMEK_ISTEDIGINIZDEN_EMIN_MISINIZ'}
                  onClick={() => cancelPayment(row.paymentId ?? 0)}
                />
              </div>
            </div>
          )}
        </>
      ),
    },
    {
      dataField: 'totalAmount',
      text: 'Miktar',
      sort: true,
      headerClasses: 'text-end',
      headerStyle: {width: '10%'},
      formatter: (cell: any, row: AdminPaymentDTO) => (
        <div className='text-end'>
          <div className='d-flex justify-content-end'>
            {row.isAmountEditable && (
              <BasePopup
                title='Ödeme Tutarı Güncelle'
                modalOpener={
                  <div className='btn btn-sm btn-icon btn-light-primary btn-xs ms-2'>
                    <i className='bi bi-pencil-fill fs-8'></i>
                  </div>
                }
              >
                {(providers: PopupProvides) => (
                  <>
                    <AdminPaymentPriceUpdate
                      paymentId={row.paymentId ?? 0}
                      defaultAmount={row.totalAmount ?? 0}
                      load={props.load}
                      close={providers.handleClose}
                    />
                  </>
                )}
              </BasePopup>
            )}
            <div className='ms-2'>{Math.round(row.totalAmount ?? 0)} ₺</div>
          </div>
        </div>
      ),
    },
  ]

  const discountColumn = {
    dataField: 'discountAmount',
    text: 'İndirim',
    sort: true,
    headerClasses: 'text-end',
    headerStyle: {width: '10%'},
    formatter: (cell: any, row: AdminPaymentDTO) => (
      <div className='d-flex row'>
        {(row.discountAmount ?? 0) < 0 && (
          <div className='text-info col-12 text-end'>{Math.round(row.discountAmount ?? 0)} ₺</div>
        )}
        {(row.discountAmount ?? 0) < 0 && (
          <div className='text-info mt-3 col-12 text-end'>{row.discountCode}</div>
        )}
      </div>
    ),
  }

  function generatePaymentDetailColumns(purchase: AdminCompanyPurchaseDTO): ColumnDescription[] {
    const uniqueServiceProviders = Array.from(
      new Set(
        purchase.payments?.flatMap(
          (payment) => payment.serviceProviders?.map((sp) => sp.serviceProviderName) || []
        ) || []
      )
    )

    const serviceProviderColumns = uniqueServiceProviders.map((sp) => {
      const col: ColumnDescription = {
        dataField: `serviceProvider_${sp}`,
        text: sp ?? '',
        sort: true,
        headerStyle: {width: '10%'},
        headerClasses: 'text-end',
        formatter: (cell: any, row: AdminPaymentDTO) => (
          <div className='text-end'>
            {_.sumBy(
              row.serviceProviders?.filter((f) => f.serviceProviderName === sp),
              (s) => s.amount ?? 0
            ).toFixed(0)}{' '}
            {'₺'}
          </div>
        ),
      }

      return col
    })

    return [...detailsColumns, ...serviceProviderColumns, discountColumn]
  }

  function getSortedPurchases() {
    return _.orderBy(
      adminState.company?.purchases ?? [],
      [(o) => (o.product?.productTypeId === 3 ? 0 : 1), (o) => new Date(o.firstPurchaseTime ?? '')],
      ['asc', 'desc']
    )
  }

  function getRowColor(productTypeId: number) {
    if (productTypeId === ProductTypeEnum.Paket) {
      return 'bg-success'
    } else if (productTypeId === ProductTypeEnum.Ek_Çözüm) {
      return 'bg-primary'
    } else {
      return 'bg-warning'
    }
  }

  const mainTableColumns: ColumnDescription[] = [
    {
      dataField: 'purchaseId',
      text: 'Satın Alınan Ürün',
      sort: true,
      headerClasses: 'text-start',
      headerStyle: {width: '100%'},
      headerFormatter: (column) => (
        <div className='row w-100 px-2'>
          <div className='col-4 ps-5'>{'Ürün'}</div>
          <div className='col-1 ps-4'>{'Başlangıç'}</div>
          <div className='col-1 ps-4'>{'Bitiş'}</div>
          <div className='col-1 text-end pe-6'>{'Toplam'}</div>
          <div className='col-1 text-end pe-6'>{'Gelecek'}</div>
          <div className='col-1 text-end pe-6'>{'Borç'}</div>
        </div>
      ),
      formatter: (cell: any, row: AdminCompanyPurchaseDTO, rowIndex: number, colIndex: number) => {
        const headerId = `kt_accordion_1_header_${rowIndex}`
        const bodyId = `kt_accordion_1_body_${rowIndex}`
        return (
          <div className='accordion' id='kt_accordion_1'>
            <div
              className={clsx('accordion-item', {
                'border border-danger': !row.isActive,
              })}
            >
              <h2 className='accordion-header' id={headerId}>
                <button
                  className={clsx(
                    'accordion-button fs-6 fw-bold collapsed bg-opacity-25',
                    getRowColor(row.product?.productTypeId ?? 0)
                  )}
                  type='button'
                  data-bs-toggle='collapse'
                  data-bs-target={'#' + bodyId}
                  aria-expanded='false'
                  aria-controls={bodyId}
                >
                  <div className='row w-100'>
                    <div className='col-4 d-flex align-items-center'>
                      {row.product?.description}
                    </div>
                    <div className='col-1 d-flex align-items-center'>
                      {moment(row.firstPurchaseTime).format('DD.MM.yyyy')}
                    </div>
                    <div className='col-1 d-flex align-items-center'>
                      {row.finishTime && moment(row.finishTime).format('DD.MM.yyyy')}
                    </div>
                    <div className='col-1 justify-content-end d-flex align-items-center'>
                      <div>{Math.round(row.totalPayment ?? 0)} ₺</div>
                    </div>
                    <div className='col-1 justify-content-end d-flex align-items-center'>
                      <div>{Math.round(row.totalDuePayment ?? 0)} ₺</div>
                    </div>
                    <div className='col-1 justify-content-end d-flex align-items-center'>
                      <div>{Math.round(row.totalDebt ?? 0)} ₺</div>
                    </div>
                  </div>
                </button>
              </h2>
              <div
                id={bodyId}
                className='accordion-collapse collapse'
                aria-labelledby={headerId}
                data-bs-parent={'#kt_accordion_1'}
              >
                <div className='accordion-body'>
                  <div className='row mb-2'>
                    {row.isStoppable && (
                      <div className='col-2 d-flex align-items-center'>
                        <div className='d-flex justify-content-center align-items-start'>
                          <AreYouSurePopup
                            modalOpener={
                              <div className='btn btn-sm btn-danger'>
                                <Translator name='SATIN_ALINAN_URUNU_DURDUR' />
                              </div>
                            }
                            message={'SATIN_ALINAN_URUNU_DURDURMEK_ISTEDIGINIZDEN_EMIN_MISINIZ'}
                            onClick={() => stopPurchase(row.purchaseId ?? 0)}
                          />
                        </div>
                      </div>
                    )}
                    {row.isStartable && (
                      <div className='col-2 d-flex align-items-center'>
                        <div className='d-flex justify-content-center align-items-start'>
                          <AreYouSurePopup
                            modalOpener={
                              <div className='btn btn-sm btn-success'>
                                <Translator name='SATIN_ALINAN_URUNU_DEVAM_ETTIR' />
                              </div>
                            }
                            message={
                              'SATIN_ALINAN_URUNU_DEVAM_ETTIRMEK_ISTEDIGINIZDEN_EMIN_MISINIZ'
                            }
                            onClick={() => startPurchase(row.purchaseId ?? 0)}
                          />
                        </div>
                      </div>
                    )}
                    {row.canEditAmount && (
                      <div className='col-3 d-flex align-items-center'>
                        <div className='d-flex justify-content-center align-items-start'>
                          <BasePopup
                            title='ÜRÜN_GELECEK_ÖDEME_TUTARINI_GÜNCELLE'
                            modalOpener={
                              <div className='btn btn-sm btn-info'>
                                <Translator name='ÜRÜN_GELECEK_ÖDEME_TUTARINI_GÜNCELLE' />
                              </div>
                            }
                          >
                            {(providers: PopupProvides) => (
                              <>
                                <AdminPurchasePriceUpdate
                                  purchaseId={row.purchaseId ?? 0}
                                  defaultAmount={0}
                                  load={props.load}
                                  close={providers.handleClose}
                                />
                              </>
                            )}
                          </BasePopup>
                        </div>
                      </div>
                    )}
                  </div>
                  <div>
                    <BootstrapTable
                      keyField='paymentId'
                      data={_.orderBy(row.payments, (o) => o.dueDate, 'asc') ?? []}
                      columns={generatePaymentDetailColumns(row)}
                      classes='table table-rounded table-striped border gt-7 gs-7'
                      headerClasses='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      },
    },
  ]

  return (
    <>
      <div className='table-responsive'>
        <>
          <div>
            <BootstrapTable
              keyField='purchaseId'
              data={getSortedPurchases()}
              columns={mainTableColumns}
              classes='table table-rounded gt-3 gs-3'
              headerClasses='fw-bold fs-6 text-gray-800 border-bottom border-gray-200 bg-info bg-opacity-25'
            />
          </div>
        </>
      </div>
    </>
  )
}

export default AdminCompanyPurchases
